import React from "react";

const Select = ({ name, label, options, error, ...rest }) => {
  return (
    <div>
      <label className="formLabel" htmlFor={name}>
        {label}
      </label>
      <select name={name} id={name} {...rest} className="form-control2">
        <option value="" />
        {options.map(option => (
          <option key={option._id} value={option._id}>
            {option.name}
          </option>
        ))}
      </select>
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default Select;
